export const getFallbackImageId = () => {
  const numberOfFallbackImages = 3;
  return Math.ceil(Math.random() * numberOfFallbackImages);
};
//# sourceMappingURL=utils.js.map